angular
	.module 'App.Component'
	.component 'treeViewComponent',
		{
			templateUrl: '@component/tree-view/tree-view.view.html'
			controller: 'TreeViewComponent'
			controllerAs: 'treeView'
			bindings:
				nodes: '<'
				selectedNodeId: '@'
				searchTerm: '@'
				searchProperty: '@?'
				externalOnSelect: '&onSelect'
		}

class TreeViewComponent extends AbstractController
	@register()

	initialize: ->
		@searchProperty ?= 'name'
		@rootIsVisible = true

	$onChanges: (changes) ->
		if changes.searchTerm? && !changes.searchTerm.isFirstChange()
			@onSearchTermChange(changes.searchTerm.currentValue)

		if changes.selectedNodeId?
			@selectNodeById(changes.selectedNodeId.currentValue)

		if changes.nodes?
			@selectNodeById(@selectedNodeId)

	onSearchTermChange: (term) ->
		term = term.toLowerCase()

		@onSearch(@nodes, term)

		@rootIsVisible = false

		for node in @nodes
			if node.visible
				@rootIsVisible = true

				break

		if term == ''
			@selectNodeById(@selectedNodeId)

	onSelect: (node) ->
		@selectNode(node)
		@externalOnSelect({node: node})

	onToggle: (node) ->
		state = !node.expanded

		@collapseNodes(@nodes)

		node.expanded = state

		@findParents(node.id,(parent) => parent.expanded = true)

	onSearch: (nodes, term) ->
		visible = false

		for node in nodes
			node.visible = false
			node.expanded = false

			if node.children?
				childrenVisible = @onSearch(node.children, term)
			else
				childrenVisible = false

			if (
				childrenVisible ||
				term == '' ||
				node[@searchProperty].toLowerCase().indexOf(term) != -1 ||
				node.id.toLowerCase().indexOf(term) != -1
			)
				node.visible = true
				node.expanded = term != ''
				visible = true

		return visible

	selectNodeById: (nodeId, nodes = @nodes) ->
		if _.isEmpty(nodeId)
			return @deselectNodes(nodes)

		for node in nodes
			if node.id == nodeId
				@selectNode(node)

				return

			if node.children?
				@selectNodeById(nodeId, node.children)

	selectNode: (node) ->
		@deselectNodes(@nodes)

		node.selected = true
		node.expanded = true

		@findParents(
			node.id,
			(parent) =>
				parent.selected = true
				parent.expanded = true
		)

	deselectNodes: (nodes) ->
		for node in nodes
			node.selected = false
			node.expanded = false

			if node.children?
				@deselectNodes(node.children)

	collapseNodes: (nodes) ->
		for node in nodes
			node.expanded = false

			if node.children?
				@collapseNodes(node.children)

	findParents: (nodeId, callback, nodes = @nodes) ->
		for node in nodes
			if node.id == nodeId
				return true

			if !node.children?
				continue

			if (@findParents(nodeId, callback, node.children))
				callback(node)

				return true

		return false
